import type { ReactNode } from 'react';
import { cn } from '../lib/utils';

type BrandLockupProps = {
  /** Product name, e.g. "Inbox Clinic". */
  brandName: string;
  /** The product's mark, e.g. `<InboxClinicLogo />`. */
  logo: ReactNode;
  className?: string;
  /** Styles the product name. Lets a product set it in its own display face. */
  nameClassName?: string;
};

/**
 * Product identity for signed-out pages: mark plus product name.
 *
 * Sits *above* the centered card on login/register/reset/invite rather than in a top bar —
 * a fixed app-style header on a signed-out page reads as if you are already inside the app.
 * Parent-company attribution is a footer concern; see `AgenticFlowByline`.
 */
export function BrandLockup({ brandName, logo, className, nameClassName }: BrandLockupProps) {
  return (
    <div className={cn('flex flex-col items-center gap-3 text-center', className)}>
      <div className="flex h-12 w-12 items-center justify-center rounded-2xl border border-primary/20 bg-primary/10 text-primary shadow-xs">
        {logo}
      </div>
      <p className={cn('text-xl font-semibold tracking-tight', nameClassName)}>{brandName}</p>
    </div>
  );
}
